export default __webpack_public_path__ + "static/media/Rectangle 1113.06638e8d.png";